import React from 'react';
import {
  Box,
  Paper,
  Typography,
  Button,
  Divider
} from '@mui/material';
import { Delete } from '@mui/icons-material';
import { Widget, PropertyPanelProps } from '../types';
import { SchemaObjectForm } from '../../components/SchemaForm';
import { ConfigValues } from '../../schema/schema';
import { useI18n } from '../../i18n';

export const PropertyPanel: React.FC<PropertyPanelProps> = ({
  widget,
  itemTypes,
  onWidgetChange,
  onWidgetDelete
}) => {
  const { t } = useI18n();

  if (!widget) {
    return (
      <Paper elevation={2} sx={{ p: 2, height: '100%' }}>
        <Typography variant="h6" color="textSecondary" textAlign="center" mt={4}>
          {t('layout.selectWidget')}
        </Typography>
      </Paper>
    );
  }

  const spec = itemTypes[widget.type];

  return (
    <Paper elevation={2} sx={{ p: 2, height: '100%', overflow: 'auto' }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography variant="h6">
          {t('layout.properties', { type: t(`layout.widget.${widget.type}`) })}
        </Typography>
        <Button
          startIcon={<Delete />}
          color="error"
          size="small"
          disabled={!onWidgetDelete}
          onClick={() => onWidgetDelete?.()}
        >
          {t('common.delete')}
        </Button>
      </Box>

      <Divider sx={{ mb: 2 }} />

      {spec ? (
        <SchemaObjectForm
          groupId="widget"
          fields={spec.fields}
          values={widget as unknown as ConfigValues}
          onChange={(next) => onWidgetChange({ ...widget, ...next, type: widget.type } as unknown as Widget)}
        />
      ) : (
        <Typography color="text.secondary">{t('layout.unknownWidget', { type: widget.type })}</Typography>
      )}
    </Paper>
  );
};
